import Clonable from './clonable'
import { OrderDirections } from '../constants'

export class QueryParams extends Clonable {
  constructor ({ period, filters, order, contexts, page, pageSize, paginate }) {
    super()
    this.period = period
    this.filters = filters
    this.order = order?.by ? new Order(order) : order
    this.contexts = contexts
    this.page = page
    this.pageSize = pageSize
    this.paginate = paginate
  }
}

export class Order extends Clonable {
  constructor ({ by = null, direction = OrderDirections.ASC } = {}) {
    super()
    this.by = by
    this.direction = direction
  }
}
